import httpService from "Root/api/httpService";
export const apiGetBlackFridayData = () => {
    const endpoint = "/api/v2/get-black-friday-data/";
    return httpService.get(endpoint + window.location.search);
};
export const getPromotionalBanner = () => {
    const endpoint = '/api/v2/promotional-banner/';
    return httpService.get(endpoint);
};
export const apiSendPostHogData = (body) => {
    const endpoint = "/api/v2/posthog/";
    return httpService.post(endpoint, body);
};
export const apiGetABtest = (test) => {
    const endpoint = "/api/v2/get-ab-status/";
    return httpService.get(endpoint.concat(test).concat("/"));
};
